import React from 'react';

const asset = (name) => `${process.env.PUBLIC_URL}/landing/${name}`;

function LandingMark({ titleClassName = 'text-[18px]' }) {
  return (
    <span className="inline-flex items-center gap-3">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-[10px] bg-[#7c3aed]">
        <img
          src={asset('logo-agil-odonto.png')}
          alt=""
          width={28}
          height={24}
          className="h-6 w-7 object-bottom"
        />
      </span>
      <span className={`font-sora font-bold leading-none text-[#0f172a] ${titleClassName}`}>
        ÁgilOdonto
      </span>
    </span>
  );
}

export default LandingMark;
